<template>
  <div class="task-content">
    <div class="task-item" @click="taskModalShow = true">
      <div class="left">
        <div class="task-header">
          <el-tooltip
            v-if="task.name"
            popper-class="task-content-tooltip"
            effect="dark"
            :content="task.name"
            placement="top-start"
          >
            <span class="task-title">{{ task.name }}</span>
          </el-tooltip>
          <span
            class="task-status"
            :class="{
              HaveInHand: task.status === 2,
              succcess: task.status === 3,
            }"
            >{{ statusName(task.status) }}</span
          >
        </div>
        <el-tooltip
          v-if="task.content"
          popper-class="task-content-tooltip"
          effect="dark"
          :content="task.content"
          placement="top-start"
        >
          <p class="task-description">{{ task.content }}</p>
        </el-tooltip>
        <p v-else class="task-description"></p>
        <div class="task-info">
          <span
            >发起人：<span class="person">{{ task?.user?.nickName }}</span>
          </span>
          <span class="fenpei">
            分配给：
            <span
              class="person"
              v-for="user in task?.userList || []"
              :key="user.id"
              >{{ user.nickName }}</span
            >
          </span>
        </div>
      </div>
      <div class="right">
        <div class="time-box">
          距离目标完成时间还有
          <strong>{{ calcDay(task.targetCompletionTime, new Date()) }}</strong>
          天
          <el-button
            class="delete-btn"
            type="danger"
            v-if="type === 'launch' && task.status === 1"
            @click.stop="deleteTaskFn"
          >
            删除
          </el-button>
        </div>
        <div class="priority">
          优先级
          <div :style="{ backgroundColor: priorityName(task.priority)?.color }">
            {{ priorityName(task.priority)?.label }}
          </div>
        </div>
        <div>发起时间：{{ task.startTime }}</div>
      </div>
    </div>
    <TaskModal :visible.sync="taskModalShow" :record="task" type="edit" />
  </div>
</template>

<script>
import bus from "./bus";
import TaskModal from "./taskModal.vue";
import dayjs from "dayjs";
import { MessageBox } from "element-ui";
import { taskStatus, priorityLevels } from "../../api/enums";
import { deleteTask } from "../../api/task";
export default {
  components: {
    TaskModal,
  },
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    type: String,
  },
  data() {
    return {
      bus,
      taskStatus,
      priorityLevels,
      taskModalShow: false,
    };
  },
  methods: {
    statusName(status) {
      const item = this.taskStatus.find((item) => item.value === status);
      return item?.label || "";
    },
    priorityName(priority) {
      const item = this.priorityLevels.find((item) => item.value === priority);
      return item;
    },
    calcDay(time1, time2) {
      if (!time1) return "未设置";
      return Math.abs(dayjs(time1).diff(time2, "day")) + 1;
    },
    deleteTaskFn() {
      MessageBox.confirm("是否确定删除此任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteTask({
          id: this.task.id,
        }).then((res) => {
          this.bus.$emit("Refresh");
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.task-content {
  min-width: 600px;
}
.task-item {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 20px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;

  cursor: pointer;
  .left {
    flex: 1;
    min-width: 0;
    // overflow: hidden;
  }
  .task-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .task-title {
      font-weight: bold;
      font-size: 18px;
      margin-right: 10px;
      flex: 1;
      min-width: 0;
      white-space: nowrap; /*设置不换行*/
      overflow: hidden; /*设置隐藏*/
      text-overflow: ellipsis; /*设置隐藏部分为省略号*/
    }

    .task-status {
      font-size: 14px;
      color: #fff;
      background-color: #666;
      padding: 2px 8px;
      border-radius: 4px;
      min-width: 42px;
      &.HaveInHand {
        background-color: #409eff;
      }
      &.succcess {
        background-color: #67c23a;
      }
    }
  }

  .task-description {
    margin: 10px 0;
    min-width: 0;
    width: 100%;
    color: #666;
    word-break: break-all;
    // display: -webkit-box;
    // -webkit-line-clamp: 1;
    // -webkit-box-orient: vertical;
    white-space: nowrap; /*设置不换行*/
    overflow: hidden; /*设置隐藏*/
    text-overflow: ellipsis; /*设置隐藏部分为省略号*/
    // display: inline-block;
  }

  .task-footer {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333;
  }

  .task-info {
    display: flex;
    align-items: center;
    span {
      margin-right: 15px;
      display: flex;
      align-items: center;
      align-items: center;
    }
    .fenpei {
      flex-wrap: wrap;
      flex: 1;
    }
  }
  .person {
    min-width: 30px;
    padding: 0 10px;
    height: 30px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #b78e6c;
    color: #fff;
    margin-bottom: 10px;
  }
  .right {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    justify-content: space-between;
    .time-box {
      padding-left: 20px;
      position: relative;
      top: -5px;
    }
    span {
      margin-right: 10px;
    }

    strong {
      color: #b78e6c;
      font-weight: 800;
      font-size: 24px;
    }

    .priority {
      padding: 2px 5px;
      border-radius: 4px;
      color: #333;
      display: flex;
      align-items: center;
      & > div {
        color: #fff;
        padding: 5px 8px;
        border-radius: 10px;
        margin-left: 10px;
      }
      &.danger {
        background-color: #f56c6c;
      }

      &.warning {
        background-color: #e6a23c;
      }

      &.success {
        background-color: #67c23a;
      }
    }
  }
}
</style>
<style>
.task-content-tooltip {
  max-width: 600px;
}
</style>